import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HierarchyService } from '../services/hierarchy.service';
import { LicenseDetailsSearchHandler } from './license-details-search.handler';

@Component({
  selector: 'sym-license-details-search',
  templateUrl: './license-details-search.component.html',
  styleUrls: ['./license-details-search.component.scss'],
})
export class LicenseDetailsSearchComponent extends LicenseDetailsSearchHandler implements OnInit {
  constructor(
    public service: HierarchyService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
